import $ from 'jquery';
import Backbone from 'backbone';
import model from 'models/admin/roleModel';
const RoleCollection = Backbone.Collection.extend({
    url: '/api/user/role-info',
    model,

    parse(data) {
        const that = this;

        if (data && data.success) {
            const roleInfoData = data.hasOwnProperty('data') ? data.data : data;
            $.each(roleInfoData, function(i, roleInfo) {
                const roleIds = [];
                for (const roleId in roleInfo.roles) {
                    roleIds.push(roleId);
                    const lookup = roleInfo.roles[roleId];
                    if (lookup.split('.').length === 4) {
                        roleInfo.globalRoleId = parseInt(roleId, 10);
                    } else {
                        roleInfo.contextRoleId = parseInt(roleId, 10);
                    }
                }
                roleInfo.roleIds = roleIds.join();
            });

            that.add(roleInfoData);
        }

        return this.models;
    },

    getRoles(collection, successFn, errorFn) {
        const that = this;

        collection.fetch({
            url: that.url,
            success(data, response) {
                that.total = that.total + response.total;
                if (response.success === false) {
                    errorFn();
                } else {
                    that.add(collection.models);
                    successFn();
                }
            },
            error() {
                errorFn();
            },
        });
    },
});

export default RoleCollection;
